import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import CircularProgress from './../../../../components/CircularProgress';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { toast } from 'react-toastify';
import PaginationComponent from './../../../common/Pagination';
import { GET_REPORT_DATA, MARK_IGNORED_DATA, Revert_Ignored_DATA, UpdateTransactionCheckNumber, UPDATE_DESCRIPTION_DATA } from '../../../../appRedux/actions/ReportDetailAction';
import { ReportType, numberWithCommas, makeLinkForQuickbooks, ModuleType, LinkType } from '../../../common/commonServices';
import CommonComments from './../../../common/Comments';
import Textarea from 'react-expanding-textarea';
import { MarkReportReview, GetReportReviewedHistory, LedgerUpdate } from '../../../../appRedux/actions/LedgerAction';
import { Accounts } from '../../../../appRedux/actions/accountAction';
import Tooltip from '@material-ui/core/Tooltip';
import TransactionEditRow from '../../../common/TransactionEditRow';
import { formatNewAccountLabel, toAccountOptions, startSave, handleLedgerResult, handleMemoResult } from '../../../common/transactionEdit';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ClearIcon from '@material-ui/icons/Clear';
import './DataEntryIssues.css';


class MissRefNo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parantData: this.props.location.state ? this.props.location.state : null,
            MissingData: [],
            companyId: 0,
            sortField: 'date',
            sortFormat: "D",
            PageNo: 1,
            PageSize: 10,
            ColorCode: "#e27b40",
            sDate: new Date(2019, 0, 1),
            eDate: new Date(),
            loading: false,
            TotalRecords: 0,
            CommentReferenceId: 0,
            IsEmbeddedPage: false,
            SelectedRecords: [],
            SelectALL: false,
            IsIgnoredFilter: false,
            isEdited: false,
            ShowHistory: true,
            HistoryData: [],
            // Transaction edit row (row click); Check No. cell keeps check-number mode
            editIndex: -1,
            accounts: [],
            accountOptions: [],
            pendingDescriptionBody: null,
            pendingTfbOnlySave: false
        }
    }

    onRowClick = (j) => {
        this.setState({ editIndex: this.state.editIndex === j ? -1 : j });
    }

    onRowSave = (item, editData) => {
        startSave(this, item, editData, ReportType.ChecksMissingReferenceNumber);
    }

    onCheckNoCellClick = (e, item) => {
        e.stopPropagation();
        this.onRowEdit(item);
    }

    onCheckboxClick = (e, item) => {
        e.stopPropagation();


        let existInArray = false;
        let data = this.state.SelectedRecords;
        if (data != null && data.length > 0 && data.indexOf(item.id) > -1) {
            existInArray = true;
        }

        if (e.target.checked) {
            if (!existInArray) {
                data.push(item.id);
            }
        }
        else {
            if (existInArray) {
                data.splice(data.indexOf(item.id), 1);
            }
        }

        let all = (data.length == this.state.MissingData.length) ? true : false;
        this.setState({ SelectedRecords: data, SelectALL: all, editIndex: -1 });

    }

    HandleClose = () => {
        this.setState({ ShowHistory: false });
    }
    SelectALL = (e) => {
        if (this.state.MissingData.length > 0) {
            if (e.target.checked) {
                let all = [];
                let data = this.state.MissingData;
                for (let i = 0; i < data.length; i++) {
                    all.push(data[i].id);
                }
                this.setState({ SelectALL: true, SelectedRecords: all });
            }
            else {
                this.setState({ SelectALL: false, SelectedRecords: [] });
            }
        }
    }

    OnApplyIgnore = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }

        let body = {
            "ids": selectedData,
            "reportType": ReportType.ChecksMissingReferenceNumber,
            "companyID": this.state.companyId
        }

        this.setState({ loading: true }, () => {

            if (this.state.IsIgnoredFilter) {
                this.props.Revert_Ignored_DATA(body);
            }
            else {
                this.props.MARK_IGNORED_DATA(body);
            }
        });

    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({
            companyId: user.companyId,
            loading: true
        }, () => {
            this.props.GetReportReviewedHistory(user.companyId, ReportType.ChecksMissingReferenceNumber)
            this.GetReportData();
            this.props.Accounts(user.companyId);
        });
    }

    onLinkClick = (e, rowData) => {
        if (e && e.stopPropagation) { e.stopPropagation(); }
        let origin = makeLinkForQuickbooks();
        window.open(origin + rowData.transactionLink);
    }

    LoadComments = (e, item) => {
        if (e && e.stopPropagation) { e.stopPropagation(); }
        this.setState({ IsCommentModelOpen: true, CommentReferenceId: item.id });
    }

    UpdateItemCommentCount = (id, clearUnread) => {
        let data = this.state.MissingData;
        data.forEach(function (item) {

            if (item.id === id) {
                // clearUnread=true zeros the badge after the comment modal is closed or reviewed
                if (clearUnread === true) { item.unreviewCommentCount = 0; } else { item.commentCount++ }
            } });

        this.setState({ MissingData: data });
    }

    CloseComments = () => {
        this.setState({ IsCommentModelOpen: false });
    }


    onSortChange = (fieldName) => {
        if (this.state.sortField === fieldName) {
            let formate = this.state.sortFormat === 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate, loading: true }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true }, () => {
                this.GetReportData();
            });
        }
    }


    onRefreshDataClick = () => {
        if (!this.state.loading) {
            this.setState({ loading: true }, () => {
                this.GetReportData(true);
            });
        }
    }
    onMarkReviewd = () => {
        this.setState({
            // IsReviewProcessing: true,
            //  loading: true
            loading: false
        }, () => {
            this.props.MarkReportReview(this.state.companyId, ReportType.ChecksMissingReferenceNumber);
        });
    }
    ChangePageSize = (size) => {

        this.setState({
            loading: true, PageSize: parseInt(size), PageNo: 1, SelectedRecords: [],
            SelectALL: false
        }, () => {
            this.GetReportData();
        });
    }

    ChangePage = (page) => {
        this.setState({
            loading: true, PageNo: page, SelectedRecords: [],
            SelectALL: false
        }, () => {
            this.GetReportData();
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.ReportData !== this.props.ReportData) {
            if (nextProps.ReportData.transactionStatus === 0) {
                var totalrecords = 0;
                if (nextProps.ReportData.returnObject != null && nextProps.ReportData.returnObject.length > 0) {
                    totalrecords = nextProps.ReportData.returnObject[0].totalrows
                }
                this.setState({ MissingData: nextProps.ReportData.returnObject, TotalRecords: totalrecords, PageSize: this.state.PageSize, PageNo: this.state.PageNo, loading: false, SelectALL: false, SelectedRecords: [], editIndex: -1 });
            } else {
                toast.error(nextProps.ReportData.resultMsg);
                this.setState({ loading: false });
            }
        }

        if (nextProps.ReportReviewdHistory !== undefined && nextProps.ReportReviewdHistory !== this.props.ReportReviewdHistory) {
            if (nextProps.ReportReviewdHistory.transactionStatus === 0) {
                this.setState({ ShowHistory: true, HistoryData: nextProps.ReportReviewdHistory.returnObject });
            }
        }
        if (nextProps.CommonUpdate !== undefined && nextProps.CommonUpdate !== this.props.CommonUpdate) {
            if (nextProps.CommonUpdate.transactionStatus === 0) {
                //   let data = this.state.ReportData;
                //   if (this.state.IsReviewProcessing == false) {
                //     // let obj = this.state.editedData;
                //     // data.map((item, index) => {
                //     //   if (item.listID === obj.listID) {
                //     //     item.vendor1099 = obj.vendor1099
                //     //   }
                //     // })

                //     this.setState({editedData: null, IsReviewProcessing: false, reportData: data }, () => { toast.success("Request Process Successfully");
                //     // this.GetReportData();
                //    });
                //   }
                //   else {
                this.setState({ IsReviewProcessing: false }, () => {
                    toast.success("Reviewed Successfully");
                    this.props.GetReportReviewedHistory(this.state.companyId, ReportType.ChecksMissingReferenceNumber)
                });
                //   }
            }
            else {
                this.setState({ loading: false }, () => { toast.error(`${nextProps.CommonUpdate.resultMsg}`); });
            }

        }
        if (nextProps.LEDGER_UPDATE !== undefined && nextProps.LEDGER_UPDATE !== this.props.LEDGER_UPDATE) {
            handleLedgerResult(this, nextProps.LEDGER_UPDATE);
        }

        if (nextProps.accounts !== this.props.accounts && nextProps.accounts && nextProps.accounts.data) {
            this.setState({ accounts: nextProps.accounts.data, accountOptions: toAccountOptions(nextProps.accounts.data) });
        }

        if (nextProps.UpdateDescription !== this.props.UpdateDescription && !handleMemoResult(this, nextProps.UpdateDescription)) {
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                this.setState({
                    loading: true, editIndex: -1, SelectALL: false, SelectedRecords: []
                }, () => {
                    toast.success(`${nextProps.UpdateDescription.resultMsg}`);
                    this.GetReportData();
                });
            }
            else {
                this.setState({
                    loading: false,
                }, () => {
                    toast.error(`${nextProps.UpdateDescription.resultMsg}`);
                });
            }
        }

        if (nextProps.UpdateCheckNo !== this.props.UpdateCheckNo) {
            if (nextProps.UpdateCheckNo.transactionStatus === 0) {
                this.setState({
                    loading: true, editIndex: -1, SelectALL: false, SelectedRecords: [], isEdited: false
                }, () => {
                    toast.success(`${nextProps.UpdateCheckNo.resultMsg}`);
                    this.GetReportData();
                });
            }
            else {
                this.setState({
                    loading: false,
                }, () => {
                    toast.error(`${nextProps.UpdateCheckNo.resultMsg}`);
                });
            }
        }
    }

    GetReportData = (IsRefresh = false) => {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.ChecksMissingReferenceNumber,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            pageNumber: state.PageNo,
            pageSize: state.PageSize,
            needUpdatQBORecords: IsRefresh,
            IsIgnore: true,
            isAllIgnoreUnignore: state.IsIgnoredFilter
        };

        this.props.GET_REPORT_DATA(body);
    }

    HandleIgnored = (event) => {
        // Reset page/selection when switching Previously Ignored filter.
        this.setState({ IsIgnoredFilter: (event.target.value == "true" ? true : false), PageNo: 1, loading: true, SelectedRecords: [], SelectALL: false }, () => { this.GetReportData() });
    }

    onRowEdit = (item) => {
        if (item.transactionType != "Payroll Check") {
            this.setState({ isEdited: true });
        }
    };

    onCancelEdit = () => {
        const updatedArray = this.state.MissingData.map(item => ({
            ...item,
            num: '', // Change the 'name' property to an empty string
        }));
        this.setState({ MissingData: updatedArray, isEdited: false });
    };

    ChangeCheckNo = (e, index) => {
        var data = this.state.MissingData;
        data[index].num = e.target.value
        this.setState({ MissingData: data });
    }

    UpdateCheckNo = () => {

        let filerData = this.state.MissingData.filter(x => x.num);
        if (filerData != null && filerData.length > 0) {
            let arrayData = []

            filerData.forEach((item) => {
                arrayData.push({ id: item.id, checkNumber: item.num });
            });

            let body = {
                lstTransactions: arrayData,
                companyId: this.state.companyId
            }
            this.setState({
                loading: true
            }, () => {
                this.props.UpdateTransactionCheckNumber(body);
            });

        } else {
            toast.error("Please enter atleast 1 record Check No.");
            return false;
        }
    }



    render() {
        let selectedItem = this.state.SelectedRecords;
        return (
            <div className="dashboardPage data-entry-issues-page miss-ref-no-page">
                {/* {this.state.ShowHistory && this.state.HistoryData != null && this.state.HistoryData.length > 0 &&
                    <React.Fragment>
                        <Dialog
                            className="comment-Top-align"
                            maxWidth="sm"
                            fullWidth={true}
                            open={true}>
                            <React.Fragment>
                                <div className="Comments modal-header"><span className="log-history-title float-left">Reviewed History </span>
                                    <Button className="jr-btn close-btn float-right" onClick={this.HandleClose}><ClearIcon /></Button>
                                </div>
                                <DialogContent>
                                    {this.state.HistoryData.length == 0 ?
                                        <div className="history-box">
                                            <p className="history-item-text">No History Found</p>
                                        </div>
                                        :
                                        <React.Fragment>
                                            {this.state.HistoryData.map((item, i) => (
                                                <div className="history-box"> */}
                                                    {/* <p className="history-item-text">
                           
                          </p>
                           */}
                                                    {/* <p className="history-date-text"> <strong style={{ color: "black" }}>  Last Reviewed  </strong> By <strong> {item.userName}</strong> <strong> on </strong>{item.stCreatedDate}</p>
                                                </div>
                                            ))}
                                        </React.Fragment>
                                    }
                                </DialogContent>
                            </React.Fragment>
                        </Dialog>
                    </React.Fragment>

                } */}
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="mb-3 mb-sm-0">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | {LinkType.MissRefNo}</h2>
                </div>
                {this.state.IsCommentModelOpen ? <CommonComments
                    CloseComments={this.CloseComments}
                    ColorCode={this.state.ColorCode}
                    ModuleType={ModuleType.GeneralReportType}
                    ReportType={ReportType.ChecksMissingReferenceNumber}
                    CompanyId={this.state.companyId}
                    RecordId={this.state.CommentReferenceId}
                    IsEmbeddedPage={this.state.IsEmbeddedPage}
                    UpdateItemCommentCount={this.UpdateItemCommentCount}
                                SilentRefreshData={() => { if (typeof this.GetReportData === "function") { this.GetReportData(false); } else if (typeof this.GetQuestions === "function") { this.GetQuestions(); } else if (typeof this.getGLData === "function") { this.getGLData(); } }}
                ></CommonComments> : ""}
                {this.state.loading ? <CircularProgress></CircularProgress>
                    :
                    <React.Fragment>
                        <div className="padding-box app-wrapper">
                            {/* Notes + right controls bottom-aligned; Update/Cancel inside same column so table does not shift. */}
                            <div className="row mt-1">
                                <div className="col-md-7">
                                    <div className="dei-tip-block">
                                        <h5 className="dei-training-tip" >Training Tip – Use the "Check" transaction type for printed or handwritten checks.</h5>
                                        <h5 className="dei-training-tip dei-tip-gap" >Use the "Expense" transaction type for service charges, debit card transactions, withdrawals, and ACH debits.</h5>
                                        <h5 className="dei-training-tip" >Please add the check numbers to the check transactions.</h5>
                                        <h5 className="dei-training-tip" >Select the non-check entries and click "Got It" to confirm you will make sure future checks and non-check transactions are recorded correctly.</h5>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className='d-flex flex-column justify-content-end align-items-end h-100'>
                                        <div className="form-group d-flex mb-0 align-items-center">
                                            <Button variant="contained" className="graycolor jr-btn bg-teal text-white refresh-btn" onClick={() => this.onMarkReviewd()}>Mark as Reviewed</Button>
                                            <Button variant="contained" style={{ backgroundColor: this.state.ColorCode }} className="jr-btn text-white refresh-btn" onClick={() => this.onRefreshDataClick()}  ><i className="zmdi zmdi-refresh "></i> Refresh Data</Button>
                                        </div>
                                        <div className="d-flex align-items-center dei-mt-8">
                                            <div className='show-previously-box'>
                                                <div className="form-group d-flex mb-0 align-items-center">
                                                    <h4 className="col-form-label mb-0">Show Previously Ignored Transactions:</h4>
                                                    <div className="dropdown-input-box">
                                                        <select className="dei-filter-select select-box arrow-box" onChange={this.HandleIgnored} value={this.state.IsIgnoredFilter} >
                                                            <option value={true}> YES </option>
                                                            <option value={false}> NO </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=''>
                                                <div className="form-group d-flex mb-0 align-items-center">
                                                    <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.OnApplyIgnore()}>{this.state.IsIgnoredFilter ? "Revert" : "Got It"}</Button>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.isEdited === true &&
                                            <div className="form-group d-flex mb-0 align-items-center dei-mt-12" >
                                                <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.UpdateCheckNo()}>Update Check No</Button>
                                                <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn redishOrangecolor" onClick={() => this.onCancelEdit()}>Cancel</Button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive-material">
                                <table className="table tablebox account-reconcilliation dei-txn-table">
                                    <thead>
                                        <tr style={{ backgroundColor: this.state.ColorCode }}>
                                            <th className={`td-width ${this.state.sortField === 'date' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('date')}><p className="table-th-title">Date</p> </th>
                                            <th className={`td-width  ${this.state.sortField === 'transactionType' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('transactionType')}><p className="table-th-title">Transaction Type</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'num' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('num')}><p className="table-th-title">Check No.</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'name' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('name')}><p className="table-th-title">Name</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'memoOrDescription' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('memoOrDescription')}><p className="table-th-title">Memo/Description</p> </th>
                                            <th className={`td-width  text-center ${this.state.sortField === 'amount' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('amount')}><p className="table-th-title">Amount</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'internalNotes' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('internalNotes')}><p className="table-th-title">Internal Notes</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'accountantComment' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('accountantComment')}><p className="table-th-title">Questions and Comments</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'newAccount' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('newAccount')}><p className="table-th-title">New Account #</p> </th>
                                            <th className="text-center dei-flag-col"><p className="table-th-title dei-flag-title">TFB</p></th>
                                            <th className="text-center dei-flag-col"><p className="table-th-title dei-flag-title">NBD</p></th>
                                            <th className="td-width-90 text-center">
                                                <label className="container101 header-check">
                                                    <input className="second-check-box" type="checkbox" checked={!!this.state.SelectALL} onClick={(e) => this.SelectALL(e)} onChange={() => { }} />
                                                    <span className="checkmark101 yellowMark white_border"></span>
                                                </label>
                                            </th>
                                            <th className="td-width-90 text-center"><img src="/vendors/WhiteCommnet.png" alt="comments" /></th>
                                            <th className="td-width-90 text-center "><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.MissingData.length > 0 ?
                                            (this.state.MissingData && this.state.MissingData.length > 0) && this.state.MissingData.map((item, j) => (
                                                <React.Fragment key={j}>
                                                    {<tr className="dei-clickable" onClick={() => this.onRowClick(j)}>
                                                        <td className={item.cpaApproved ? "icon-check" : ""} title={item.date || ''}>{item.date}</td>
                                                        <td title={item.transactionType || ''}>{item.transactionType} </td>
                                                        {this.state.isEdited === true && item.transactionType != "Payroll Check" ?
                                                            <td onClick={(e) => e.stopPropagation()} className="dei-valign-mid">
                                                                {/* Vertically center Check No. input in the row. */}
                                                                <div className="dei-row-40">
                                                                    <Textarea className="placheholder-color dei-inline-input"
                                                                        value={item.num} name="num"
                                                                        
                                                                        resize={"false"} placeholder="" onChange={(e) => this.ChangeCheckNo(e, j)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            :
                                                            <td title={item.transactionType != "Payroll Check" ? "Click to enter check numbers" : ''} onClick={(e) => this.onCheckNoCellClick(e, item)}>{item.num} </td>
                                                        }
                                                        <td title={item.name || ''}>{item.name}</td>
                                                        <td title={item.memoOrDescription || ''}>{item.memoOrDescription}</td>
                                                        <td className="text-center">{numberWithCommas(item.amount)}</td>
                                                        <td title={item.internalNotes || ''}>{item.internalNotes}</td>
                                                        <td title={item.accountantComment || ''}>{item.accountantComment}</td>
                                                        <td title={formatNewAccountLabel(item, this.state.accounts)}>{formatNewAccountLabel(item, this.state.accounts)}</td>
                                                        <td className="text-center">{item.taxableFringeBenefit ? <Tooltip title="Taxable Fringe Benefit" placement="top-start"><i className="zmdi zmdi-check"></i></Tooltip> : ''}</td>
                                                        <td className="text-center">{item.needsBetterDescription ? <Tooltip title="Needs Better Description" placement="top-start"><i className="zmdi zmdi-check"></i></Tooltip> : ''}</td>

                                                        <td onClick={(e) => e.stopPropagation()}>
                                                            <label className="container101">
                                                                <input
                                                                    className="second-check-box"
                                                                    type="checkbox"
                                                                    checked={!!(this.state.SelectALL || (selectedItem.length > 0 && selectedItem.indexOf(item.id) > -1))}
                                                                    onClick={(e) => this.onCheckboxClick(e, item)}
                                                                    onChange={() => { }}
                                                                />
                                                                <span className="checkmark101 green_CheckMark"></span>
                                                            </label>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                            <div className="panel-commentCount">
                                                                <img src="/vendors/Vector Smart Object.png" alt="comments" className={item.commentCount === 0 ? "disableCommentsOpacity" : ""} onClick={(e) => this.LoadComments(e, item)}></img>
                                                                {item.unreviewCommentCount !== 0 && <span className="badge badge-pill badge-danger ng-star-inserted">{item.unreviewCommentCount}</span>}
                                                            </div>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}><img src="/vendors/Shape 1.png" alt="link" onClick={(e) => this.onLinkClick(e, item)}></img></td>
                                                    </tr>
                                                    }
                                                    {this.state.editIndex === j &&
                                                        <TransactionEditRow
                                                            item={item}
                                                            rowKey={item.id}
                                                            colSpan={14}
                                                            accountOptions={this.state.accountOptions}
                                                            onSave={(editData) => this.onRowSave(item, editData)}
                                                            onCancel={() => this.setState({ editIndex: -1 })}
                                                        />}
                                                </React.Fragment>
                                            ))
                                            :
                                            <tr>
                                                <td colSpan="14" align="center">
                                                    No issues here! Keep up the good work!
                                                </td>
                                            </tr>
                                        }

                                    </tbody>
                                </table>
                            </div>
                            <PaginationComponent
                                selectedPageNo={this.state.PageNo}
                                selectedSize={this.state.PageSize}
                                TotalRecords={this.state.TotalRecords}
                                ChangePageSize={this.ChangePageSize}
                                ChangePage={this.ChangePage}
                                CurrentRecords={this.state.MissingData.length}
                            >
                            </PaginationComponent>
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        UpdateDescription: state.ReportData.UpdateDescription,
        UpdateCheckNo: state.ReportData.UpdateCheckNo,
        CommonUpdate: state.ledgers.CommonUpdate,
        ReportReviewdHistory: state.ledgers.ReportReviewedHistory,
        LEDGER_UPDATE: state.ledgers.LEDGER_UPDATE,
        accounts: state.accounts.accountsData
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_REPORT_DATA,
        MARK_IGNORED_DATA,
        MarkReportReview,
        Revert_Ignored_DATA,
        GetReportReviewedHistory,
        UpdateTransactionCheckNumber,
        LedgerUpdate,
        UPDATE_DESCRIPTION_DATA,
        Accounts
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MissRefNo);